import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src992805003/src/alouette/node_modules/@mui/material/Box/Box.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src992805003/src/alouette/node_modules/@mui/material/CircularProgress/CircularProgress.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src992805003/src/alouette/node_modules/@mui/material/Container/Container.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src992805003/src/alouette/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src992805003/src/alouette/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
